import React from 'react';
import { Card, ProgressBar, Row, Col } from 'react-bootstrap';

const AudienceBrandAndInterests = ({ brandData, interestData }) => {
  return (
    brandData.length > 0 && interestData.length > 0 && (
      <Card className="border rounded-0 brand-affinity">
        <Card.Body className="py-4">
          <Row className="g-4">
            <Col md={6}>
              <h6 className="mb-0 sub-heading">Audience brand affinity</h6>
              <small className="sub-text">Brands followed by the audience</small>
              <div className="mt-3 overflow-container border audience-border-radius p-3">
                {brandData.map((brand, index) => (
                  <div key={index} className="mb-2">
                    <div className="d-flex justify-content-between">
                      <span className='content-text-value'>{brand.name}</span>
                      <span className='content-text-value'>{brand.value.toFixed(2)}%</span>
                    </div>
                    <ProgressBar
                      now={brand.value}
                      className="custom-progress-bar"
                      max={brand.value < 1 ? 1 : 100}
                    />
                  </div>
                ))}
              </div>
            </Col>

            <Col md={6}>
              <h6 className="mb-0 sub-heading">Audience interests</h6>
              <small className="sub-text">Interests and topics that the audience posts about</small>
              <div className="mt-3 overflow-container border audience-border-radius p-3">
                {interestData.map((interest, index) => (
                  <div key={index} className="mb-2">
                    <div className="d-flex justify-content-between">
                      <span className='content-text-value'>{interest.name}</span>
                      <span className='content-text-value'>{interest.value.toFixed(2)}%</span>
                    </div>
                    <ProgressBar now={interest.value} className="custom-progress-bar" />
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    )
  );
};

export default AudienceBrandAndInterests;